<div
    class="rounded-lg py-4 px-5 border border-solid"
    [ngClass]="
        isExpired()
            ? 'bg-[var(--error-color-50)] border-[var(--error-color-300)]'
            : 'bg-[var(--success-color-50)] border-[var(--success-color-300)]'
    "
>
    <div class="flex justify-between items-start gap-3 mb-2">
        <h3 class="font-semibold text-lg m-0">Card on File</h3>
        <div class="flex flex-wrap gap-2 justify-end shrink-0">
            @if (card.isDefault) {
                <span
                    class="font-medium text-xs tracking-wider text-[var(--primary-color-700)] bg-[var(--primary-color-100)] py-[0.15rem] px-2 rounded"
                >
                    Default
                </span>
            }
            @if (isExpired()) {
                <span
                    class="font-medium text-xs tracking-wider text-[var(--error-color-800)] bg-[var(--error-color-100)] py-[0.15rem] px-2 rounded"
                >
                    Expired
                </span>
            }
        </div>
    </div>

    <div class="text-sm flex flex-col gap-1 [&>p]:m-0">
        <p>
            <span class="font-medium">Credit Card: </span>
            {{ cardTypeLabelMapping[card.cardType] }} ending in
            {{ card.truncatedCardNumber }}

            <app-card-type-icon class="ml-2" [cardType]="card.cardType" />
        </p>
        <p>
            <span class="font-medium">Name on Card:</span>
            {{ card.cardName }}
        </p>
        <p>
            <span class="font-medium">{{
                isExpired() ? 'Expired On:' : 'Expires On:'
            }}</span>
            {{ formatExpirationMonthForDisplay() }}/{{ card.expirationYear }}
        </p>
    </div>

    <div class="mt-3 flex justify-start gap-2">
        <button
            mat-button
            color="primary"
            (click)="handleEditCreditCardClick()"
        >
            Edit
        </button>
        <button mat-button color="warn" (click)="handleDeleteCreditCardClick()">
            Delete
        </button>
    </div>
</div>
